<template>
  <div class="s-wrapper" :class="[`s-wrapper--${viewMode}`, isLoading ? 'is-loading' : null]">
    <div class="s-header">
      <div class="s-header-main">
        <p class="s-header-total" aria-live="polite">{{ Translator('front.search.results', {total: totalNotices}) }}</p>
        <p class="s-header-search">
          <span class="s-header-search-query" v-if="query">{{ query }}</span>
          <span class="s-header-search-facets" v-if="facets">
            <span class="color-second-background" v-for="facet in facets" :key="facet.id">{{ facet.name ? facet.name : facet.content }}</span>
          </span>
          <v-tooltip top v-if="query || (facets && facets.length > 0)">
            <template v-slot:activator="{ on }" >
              <button type="button" class="s-header-clear" @click="onClearFilters()" v-on="on">
                <i class="ico ico-reset" aria-hidden="true"></i>
                <span class="sr-only">{{ Translator('front.search.reset') }}</span>
              </button>
            </template>
          </v-tooltip>
        </p>
      </div>
      <div class="s-header-actions">
        <button type="button" class="button-flat" @click="onAddCart()" :title="Translator('front.cart.add_all_to_cart')">
          {{ Translator('front.cart.add_to_cart') }}
        </button>
        <div class="s-header-mode">
          <button type="button" class="button-light button-icon" :aria-pressed="viewMode === 'line'? 'true': 'false'" @click="onActiveMode('line')" v-bind:class="{ 'is-active': viewMode === 'line' }">
            <i class="ico ico-view-list"></i>
            <span class="hide-access">{{ Translator('front.search.mode_line') }}</span>
          </button>
          <button type="button" class="button-light button-icon" :aria-pressed="viewMode === 'card'? 'true': 'false'" @click="onActiveMode('card')" v-bind:class="{ 'is-active': viewMode === 'card' }">
            <i class="ico ico-view-grid"></i>
            <span class="hide-access">{{ Translator('front.search.mode_card') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="s-list">
      <Notice v-for="notice in notices" :key="notice.id" :datas="notice" :viewMode="viewMode" />
    </div>
    <v-pagination v-if="pagination.pages > 1" v-model="pagination.page" :length="pagination.pages" :total-visible="7" @input="onGetPage"></v-pagination>
  </div>
</template>
<script>
import NoticesService from '@/front/services/notices';
import Notice from '@/front/components/Notice';
import ConfigService from '@/front/services/config';
import SearchService from '@/front/services/search';

export default {
  name: 'Notices',
  props: [],
  components: {
    Notice,
  },
  data: () => ({
    isLoading: false,
    viewMode: localStorage.getItem(`search-viewMode-${ConfigService.get('noticeCollectionsFilter')}`) || ConfigService.get('renderMode') || 'line',
    notices: [],
    totalNotices: 0,
    query: null,
    facets: null,
    pagination: {
      page: 1,
      pages: 1,
      items_per_page: SearchService.paramsNotices.items_per_page,
    }
  }),

  created() {
    window.CartService.on('update', this._onUpdateCart );
    SearchService.on('is-ready', () => NoticesService.getAll() );
    SearchService.on('selected', this._onUpdateSelected);
    SearchService.on('update-params', this._onUpdateParams);
    NoticesService.on('updated', this._updateList);
    NoticesService.on('searching', this._toggleLoader);
  },

  mounted() {
    this.pagination.page = SearchService.paramsNotices.page;
  },

  beforeDestroy() {
    window.CartService.off('update', this._onUpdateCart );

    SearchService.off('selected', this._onUpdateSelected);
    SearchService.off('update-params', this._onUpdateParams);
    NoticesService.off('updated', this._updateList);
    NoticesService.off('searching', this._toggleLoader);
  },

  methods: {
    onGetPage(page) {
      SearchService.page = page;
      window.scrollTo(0, this.$el.offsetTop);
    },

    onAddCart() {
      this.notices.forEach(notice => {
        window.CartService.add( notice.id );
      });
    },

    onClearFilters() {
      SearchService.clear();
    },

    onActiveMode(mode) {
      localStorage.setItem(`search-viewMode-${ConfigService.get('noticeCollectionsFilter')}`, mode);
      this.viewMode = mode;
    },

    _onUpdateSelected() {
      this.facets = SearchService.selectedFacets;
    },

    _onUpdateParams() {
      this.query = SearchService.query;
      this.facets = SearchService.selectedFacets;
      NoticesService.getAll();
    },

    _updateList (datas) {
      this.notices = datas['hydra:member'];
      this.totalNotices = datas['hydra:totalItems']
      this.pagination.pages = Math.ceil(datas['hydra:totalItems'] / this.pagination.items_per_page)
    },

    _toggleLoader( loading ) {
      this.isLoading = loading;
    },

    _onUpdateCart() {
      this.$children.forEach( item => {
        if(item.cartUpdated) item.cartUpdated();
      });
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
<style scoped lang="scss">
  .viewer-element {
    .s-wrapper {
      @include vertical-spacing-bottom;
      margin-right: 0;
      width: 100%;
      &.is-loading {
        pointer-events: none;
        &::before {
          content: '';
          position: absolute;
          z-index: 2;
          left: 50%;
          top: rem(150);
          border-radius: rem(8);
          background-color: rgba($white, .4);
          width: rem(120);
          height: rem(120);
          transform: translateX(-50%) translateY(-50%);
        }
        @include loader {
          top: rem(150);
          z-index: 3;
        }
      }
    }
    .s-header {
      display: flex;
      margin-bottom: rem(20);
      @include mobile {
        flex-direction: column-reverse;
        gap: rem(5);
      }
      @include tablet {
        justify-content: space-between;
        align-items: center;
      }
      .s-header-clear {
        @include resetBtn;
        width: rem(30);
        height: rem(30);
        line-height: rem(30);
        text-align: center;
        font-size: rem(25);
        vertical-align: middle;
        margin-left: rem(15);
      }
      .s-header-actions {
        display: flex;
        @include mobile {
          align-self: flex-end;
        }
      }
      .s-header-total {
        font-weight: bold;
      }
      .s-header-mode {
        margin-left: rem(10);
        @include phablet {
          margin-left: rem(40);
        }
        .button-light.is-active {
          pointer-events: none;
        }
      }
      .s-header-search {
        margin-top: rem(10);
        .s-header-search-query {
          font-weight: bold;
          margin-right: rem(10);
          font-size: .9em;
        }
        .s-header-search-facets {
          span {
            font-size: .7em;
            padding: rem(2) rem(10);
            margin: rem(2);
            border-radius: rem(20);
            white-space: nowrap;
          }
        }
      }
    }
    .s-list {
      display: flex;
      flex-wrap: wrap;
      margin-left: rem(-15);
      margin-right: rem(-15);
    }
  }
</style>